/**
 * Transient suppression window used to ignore the canvas `click` that
 * immediately follows a desktop pin placement.
 */
const MARKER_CREATION_SUPPRESSION_MS = 300;

export const markerCreationSuppression = { lastCreatedAt: 0 };

export function markMarkerCreated(): void {
    markerCreationSuppression.lastCreatedAt = Date.now();
}

export function isWithinMarkerCreationSuppressionWindow(): boolean {
    return Date.now() - markerCreationSuppression.lastCreatedAt < MARKER_CREATION_SUPPRESSION_MS;
}
